import React, { useState } from 'react';
import { Card, CardBody, Button, Input, Chip } from '@heroui/react';
import { InfoIcon } from '../../../../../components/icons';
import { Typography } from '../../../../../components';
import { OfferTabWithGuarantor } from './OfferTabWithGuarantor';
import { useTranslations } from '../../../../../contexts/translation.context';

interface OfferTabProps {
  modelId?: string;
  accountData?: any;
}

export const OfferTab: React.FC<OfferTabProps> = ({ modelId, accountData }) => {
  const { t } = useTranslations();
  const [depositAmount, setDepositAmount] = useState('');

  // Определяем наличие гаранта (можно заменить на реальную логику)
  const hasGuarantor = accountData?.hasGuarantor || false;

  // Если есть гарант, показываем версию с настройками оффера
  // if (hasGuarantor) {
  if (true) {
    return <OfferTabWithGuarantor modelId={modelId} accountData={accountData} />;
  }

  // Если нет гаранта, показываем версию с депозитом
  const handleDepositClick = () => {
    // Логика для внесения гарантийного депозита
    console.log('Внести гарантийный депозит для модели:', modelId, 'Сумма:', depositAmount);
  };

  return (
    <div className="space-y-6">
      {/* Заголовок */}
      <div>
        <Typography variant="h6">Гарантийный депозит для запуска оффера</Typography>
      </div>
      <Card
        className={`border border-l-[0.1875rem] border-l-partner rounded-none shadow-sm bg-gray-98`}
      >
        <CardBody className="p-4">
          <div className="flex flex-col gap-6">
            {/* Первый блок */}
            <div className="flex gap-4">
              <div className="icon size-8 md:size-9">
                <InfoIcon />
              </div>
              <div>
                <Typography variant="body2" className="!text-partner font-medium leading-5 mb-0.5">
                  Для размещения вашего оффера и старта работы требуется гарантийный депозит.
                </Typography>
              </div>
            </div>

            {/* Второй блок */}
            <div className="flex gap-4">
              <div className="icon size-8 md:size-9">
                <InfoIcon />
              </div>
              <div>
                <Typography variant="body2" className="!text-partner font-medium leading-5 mb-0.5">
                  Что нужно знать о гаранте
                </Typography>
                <div className="space-y-1.5">
                  <Typography variant="body2" className="text-auth-inkAlt leading-5">
                    Минимальный размер депозита — $200 за анкету.
                  </Typography>
                  <Typography variant="body2" className="text-auth-muted leading-5">
                    Сумма пересматривается ежемесячно и зависит от вашего дохода за последние 30
                    дней.
                  </Typography>
                  <Typography variant="body2" className="text-auth-muted leading-5">
                    Гарантийный взнос необходим для стабильного и эффективного сотрудничества.
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};
